import React from 'react';
import { CheckCircle2Icon, ShieldCheckIcon, TruckIcon, HeartIcon, ClockIcon } from 'lucide-react';
export function WhyShopSection() {
  const trustPoints = ["Real local experts who know your pet's needs",, 'Price match guarantee on all stocked items', 'Free local delivery on orders over $100', 'Customer Care Club rewards and exclusive deals'];
  return <section className="section-padding bg-white" data-id="element-355">
      <div className="container-wide" data-id="element-356">
        <div className="bg-warm-50 rounded-3xl overflow-hidden shadow-sm border border-warm-200" data-id="element-357">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-358">
            {/* Image Side — Two stacked store photos */}
            <div className="relative flex flex-col" data-id="element-359">
              <div className="relative h-full min-h-[250px] lg:min-h-[300px] overflow-hidden" data-id="element-360">
                <img src="https://cdn.magicpatterns.com/uploads/gYcRdpPc38QZ66AgQ6wmdk/Not_just_another_faceless_online_store_malaga.png" alt="Better Pets and Gardens Malaga Store" className="w-full h-full object-cover object-top" data-id="element-361" />
                {/* WA Owned badge overlay */}
                <div className="absolute top-6 left-6 bg-white rounded-2xl p-3 shadow-elevated" data-id="element-362">
                  <img src="https://cdn.magicpatterns.com/uploads/cHcSSRvAwPTr86uE9Kk5yi/WA_OWned.webp" alt="Western Australian Owned" className="w-14 h-14 rounded-full object-cover" data-id="element-363" />
                </div>
              </div>
              <div className="relative h-full min-h-[250px] lg:min-h-[300px] overflow-hidden hidden lg:block" data-id="element-364">
                <img src="https://cdn.magicpatterns.com/uploads/955MqdeHatH5mLbKcwtLuc/Not_just_another_faceless_online_store.png" alt="Better Pets and Gardens Store Front" className="w-full h-full object-cover object-center" data-id="element-365" />
              </div>
            </div>

            {/* Content Side */}
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-366">
              <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-gray-900 mb-4 leading-tight" data-id="element-367">
                Not just another
                <br data-id="element-368" />
                faceless online store.
              </h2>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-369">
                We're your local experts dedicated to helping your pets thrive,
                your garden grow, and your pool sparkle.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-370">
                {trustPoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-371">
                    <CheckCircle2Icon className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-372" />
                    <span className="text-gray-800 font-medium" data-id="element-373">{point}</span>
                  </li>)}
              </ul>

              <div className="flex flex-wrap gap-4" data-id="element-374">
                <button className="btn-primary shadow-soft active:scale-95" data-id="element-375">
                  Find Your Local Store
                </button>
                <button className="btn-secondary bg-white active:scale-95" data-id="element-376">
                  Learn More About Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}